<template>
  <div class="centered">
    <!-- Show convenience fee message -->
    <ConvenienceFeeMessageComponent />
    <div class="row custom-amount-container">
      <div class="cell">
        <label
          v-if="showCreditCardLimitDisclaimer()"
          for="pay-amount"
        >Amount (${{ invoice.remaing_digital_wallet_amount }} limit)</label>
        <label
          v-else
          for="pay-amount"
        >Amount</label>
        <input
          id="pay-amount"
          v-model="customAmount"
          class="input amount-input"
          name="pay-amount"
          type="number"
          @change="customAmountChanged"
        >
        <label
          v-if="showCreditCardLimitDisclaimer()"
          class="amount-disclaimer"
        >Credit Card and digital wallets are limited to $15,000. Balance will be due by Zelle, ACH, or Wire Transfer.</label>
      </div>
    </div>
    <!-- Show loading spinner if loading -->
    <LoadingComponent v-if="isLoading" />
    <div
      v-show="isLoading === false && !error"
      id="google-pay-button-container"
    />
    <!-- Show error -->
    <BraintreeErrorMessageComponent
      v-if="error"
      :error="error"
    />
    <!-- End GooglePay component -->
  </div>
</template>
<script>
import BraintreeError from '../../../../errors/BraintreeError'
import BraintreeErrorMessageComponent from '../../Shared/BraintreeErrorMessageComponent.vue'
import LoadingComponent from '../../Shared/LoadingComponent'
import ConvenienceFeeMessageComponent from '../../Shared/ConvenienceFeeMessageComponent.vue'
export default {
  name: 'GooglePayComponent',
  components: {
    BraintreeErrorMessageComponent,
    LoadingComponent,
    ConvenienceFeeMessageComponent
  },
  props: ['braintreeInstance', 'invoice', 'disablePaymentMethod', 'deviceData'],
  data: function () {
    return {
      isLoading: true,
      error: null,
      customAmount: null,
    }
  },
  created () {
    this.init()
  },
  methods: {
    /**
     * Init the google pay button
     */
    init: async function () {
      var self = this

      if(this.invoice !== undefined){
        this.customAmount = this.invoice.remaing_digital_wallet_amount ? this.invoice.remaing_digital_wallet_amount.toFixed(2) : 0
      }

      // Create a Google Pay instance.
      const googlePaymentInstance = await window.braintree.googlePayment.create({
        client: this.braintreeInstance,
        googlePayVersion: 2,
        googleMerchantId: 'BCR2DN6TQ6V3HHIW'
      })

      // Set a paymentsClient
      var paymentsClient = new window.google.payments.api.PaymentsClient({
        environment: 'PRODUCTION' // Or 'TEST'
      })

      const isReadyToPay = await paymentsClient.isReadyToPay({
        // see https://developers.google.com/pay/api/web/reference/object#IsReadyToPayRequest for all options
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods:
          googlePaymentInstance.createPaymentDataRequest()
            .allowedPaymentMethods,
        existingPaymentMethodRequired: true
      })
      if (isReadyToPay.result) {
        // Set up Google Pay button
        this.isLoading = false

        const container = document.getElementById(
          'google-pay-button-container'
        )
        const button = paymentsClient.createButton({
          buttonColor: 'default',
          buttonType: 'pay',
          buttonSizeMode: 'fill',
          onClick: () => {
            var paymentDataRequest = googlePaymentInstance.createPaymentDataRequest({
              transactionInfo: {
                currencyCode: 'USD',
                totalPriceStatus: 'FINAL',
                totalPrice: self.customAmount + ''
              }
            })

            paymentsClient.loadPaymentData(paymentDataRequest).then(function (paymentData) {
              googlePaymentInstance.parseResponse(paymentData, function (err, result) {
                if (err) {
                  const exception = new BraintreeError(err)
                  this.error = exception.getMessage()
                  return
                }

                // Send result.nonce to your server
                // result.type may be either "AndroidPayCard|GooglePayCard" or "PayPalAccount", and
                // paymentData will contain the billingAddress for card payments
                const nonce = result.nonce
                const paymentForm = {
                  nonce: nonce,
                  type: 'google_pay',
                  submitCC: false,
                  deviceData: self.deviceData,
                  isPartialPayment: self.invoice.invoice_balance == self.customAmount ? false : true,
                  amount: self.customAmount,
                  savedPaymentMethod: false
                }

                self.$store.dispatch('updatePaymentForm', paymentForm)
              })
            }).catch(function (err) {
              const exception = new BraintreeError(err)
              this.error = exception.getMessage()
            })
          },
          allowedPaymentMethods:
            googlePaymentInstance.createPaymentDataRequest()
              .allowedPaymentMethods
        })
        container.appendChild(button)
        return
      }

      // Set the errors for the UI
      this.isLoading = false
      this.error = 'Google Pay is not available'
    },
    customAmountChanged: function (event) {
      const current = event.target.value
      const amount = parseFloat(current)
      if(amount > this.invoice.remaing_digital_wallet_amount){
        this.customAmount = this.invoice.remaing_digital_wallet_amount
      }
      else{
        this.customAmount = amount
      }
    },
    showCreditCardLimitDisclaimer: function () {
      return this.invoice.invoice_total > 15000
    },
    /**
     * To force a payment method to be hidden from list.
     */
    disable: function () {
      this.disablePaymentMethod(this.$options.name)
    }
  }
}
</script>
<style scoped>
#google-pay-button-container {
  width: 300px;
  height: 40px;
  margin-top: 1em;
  margin-bottom: 1em;
}
.amount-input {
  margin-bottom: 0;
}
.amount-input {
  margin-bottom: 0;
}
.centered {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
}

.custom-amount-container {
  max-width: 300px;
  width: 100%;
}

.amount-disclaimer {
  text-align: center;
  padding-top: 0.5rem;
  padding-bottom: 1rem;
  font-size: 0.8em;
}
</style>
